import React from 'react';
import {Tag} from 'antd';

export default function StatusTag({isActive, activeText = 'Ativo', inactiveText = 'Inativo'}) {
    return (
        <Tag color={isActive ? 'green' : 'red'}>
            {isActive ? activeText : inactiveText}
        </Tag>
    );
}